import { useState } from 'react';
import { AuthProvider, useAuth } from './AdminContext';
import AdminLogin from './AdminLogin';
import AdminDashboard from './AdminDashboard';
import LaborersModule from './LaborersModule';
import SuppliersModule from './SuppliersModule';
import PartnersModule from './PartnersModule';
import CardScanner from './CardScanner';

const AdminContent = () => {
  const { isAuthenticated, isLoading, logout } = useAuth();
  const [currentView, setCurrentView] = useState('dashboard');
  const [viewParams, setViewParams] = useState({});

  const handleNavigate = (view, params = {}) => {
    setCurrentView(view);
    setViewParams(params);
  };

  const handleBack = () => {
    setCurrentView('dashboard');
    setViewParams({});
  };

  const handleLogout = () => {
    logout();
    setCurrentView('dashboard');
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-[#060B14] flex items-center justify-center" data-testid="admin-loading">
        <div className="animate-spin w-8 h-8 border-2 border-[#25D366] border-t-transparent rounded-full"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <AdminLogin />;
  }

  // Render based on current view
  switch (currentView) {
    case 'laborers':
      return (
        <LaborersModule 
          onBack={handleBack} 
          initialAction={viewParams.action}
        />
      );
    case 'suppliers':
      return (
        <SuppliersModule 
          onBack={handleBack} 
          initialAction={viewParams.action}
        />
      );
    case 'partners':
      return (
        <PartnersModule 
          onBack={handleBack} 
          initialAction={viewParams.action}
        />
      );
    case 'scanner':
      return <CardScanner onBack={handleBack} />;
    default:
      return (
        <AdminDashboard 
          onNavigate={handleNavigate} 
          onLogout={handleLogout}
        />
      );
  }
};

const AdminApp = () => {
  return (
    <AuthProvider>
      <div data-testid="admin-app">
        <AdminContent />
      </div>
    </AuthProvider>
  );
};

export default AdminApp;
